/**
 * @author Mustafa Omran  <promustafaomran@hotmail.com>
 */

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LazyLoadImagesModule } from 'ngx-lazy-load-images';

/**
 * services
 */
import { OAuthService } from './MartMax/services/oauth/oauth.service';
import { Handler } from './MartMax/services/handler';

/**
 * martmax components
 */

/**
 * Home Page
 */
import { HomeComponent } from './MartMax/components/home.component';
import { FooterComponent } from './MartMax/components/home-page/footer/footer.component';
import { HeaderBannerComponent } from './MartMax/components/home-page/header-banner/header-banner.component';
import { StickyComponent } from './MartMax/components/home-page/sticky/sticky.component';
import { MegaMenuComponent } from './MartMax/components/home-page/mega-menu/mega-menu.component';
import { CategoriesComponent } from './MartMax/components/home-page/categories/categories.component';
import { TopBrandsComponent } from './MartMax/components/home-page/top-brands/top-brands.component';
import { TopStoresComponent } from './MartMax/components/home-page/top-stores/top-stores.component';
import { TopDealsComponent } from './MartMax/components/home-page/top-deals/top-deals.component';
import { HeaderComponent } from './MartMax/components/home-page/header/header.component'
import { FeaturedCategoriesComponent } from './MartMax/components/home-page/featured-categories/featured-categories.component';

/**
 * pipes
 */
import { MOloop } from './MartMax/pipes/mo-loop.pipe';
import { MOskipDigitsPipe } from './MartMax/pipes/MOskipdigits';

/**
 * third libraries
 */
import { SwiperModule } from 'angular2-useful-swiper';
import { NgProgressModule } from 'ngx-progressbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CartService } from "./MartMax/services/cart/cart.service";
import { from } from 'rxjs/observable/from';

@NgModule({
  declarations: [
    /**
     * Home page
     */
    AppComponent,
    HomeComponent,
    HeaderBannerComponent,
    StickyComponent,
    MegaMenuComponent,
    CategoriesComponent,
    TopBrandsComponent,
    TopStoresComponent,
    TopDealsComponent,
    FeaturedCategoriesComponent,
    FooterComponent,
    HeaderComponent,
    /**
     * pipes
     */
    MOloop,
    MOskipDigitsPipe,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'martmax' }),
    HttpModule,
    FormsModule,
    SwiperModule,
    NgProgressModule,
    AppRoutingModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    LazyLoadImagesModule,
  ],

  providers: [
    OAuthService,
    Handler,
    CartService,
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.module.ts